import * as React from 'react';
import { ChevronRightIcon } from 'lucide-react';

import { PaginationLink } from './pagination-link';

export function PaginationNext(
    props: React.ComponentProps<typeof PaginationLink>
) {
    return (
        <PaginationLink aria-label="Go to next page" {...props}>
            <ChevronRightIcon className="size-6" />
        </PaginationLink>
    );
}
